import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('UnitOfMeasure?page=' + page,  {params});
    }, 
    show(id) {
        return Service().get('UnitOfMeasure/show/'+id);
    },    
    create(params) {
        return Service().post('UnitOfMeasure/add', params);
    },
    update(id, params) {
        return Service().post('UnitOfMeasure/update/'+id, params);
    },
    delete(id) {
        return Service().post('UnitOfMeasure/delete/'+id);
    }
}